import React, { useState, useEffect,useContext } from "react";

import { AppContext } from "../../AppContext";

import { fetchCall } from "../../common/FetchHelpers";

import ErrorComp from "../common/ErrorComp";
import LoadingComp from "../common/LoadingComp";


import DocumentTypesComp from "./DocumentTypesComp";

import DocumentSearch from './DocumentSearch';
import DocumentEditor from './DocumentEditor';


const DocumentComp = (props)=> {

    const docTypesUrl = "api/document/doctypes";

    const emptyEditorItem = {   
        id:-1,
        status:"",
        attachment:null,
        template:{},
        formData:{}
      }


    const [appContext, setAppContext] = useContext(AppContext);

    const [showingList, setShowingList] = useState(true);
    const [showingDetail, setShowingDetail] = useState(false);
    const [showingEditor, setShowingEditor] = useState(false);
    const [showError, setShowError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [editorMode, setEditorMode] = useState("NEW");
    const [editorItem, setEditorItem] = useState(emptyEditorItem);
    const [docTypes, setDocTypes] = useState([]);

    const [controlParam, setControlParam] = useState({
        approved: 0,
        pending: 0,
        rejected: 0,
        btnAddLabel: "Create a New Request",
        mode: "view",
        addNewClickHandler,
        showListHandler,
      });
    

      const addNewClickHandler = (docType) => {
        const tempItem = {...emptyEditorItem, typeId:docType.id, enableOnBehalf:docType.enableOnBehalf, templateStr:docType.templateStr};
        setEditorItem(tempItem);
        setControlParam((p) => {
          return { ...p, mode: "add" };
        });
    
    
        setShowingList(false);
        setShowingEditor(true);
      };


    const showListHandler = () => {
        setControlParam((p) => {
          return { ...p, mode: "view" };
        });
        setShowingEditor(false);
        setShowingList(true);
      };
      

    const handleUpdate=(data)=>{
      setEditorMode("UPDATE");
      console.log(data);
      setEditorItem(data);
      setShowingList(false);
      setShowingEditor(true);
    };

      useEffect(()=>{

        fetchCall(docTypesUrl)
          .then((result)=>{
            setDocTypes(result);
            setLoading(false);

          },
          (err)=>{
            setLoading(false);
            setShowError(true);
            console.log(err);

          }
        );
      },[]);



    return (
        <div className={appContext.sidebarCollapsed?"content-wrapper sidebar-collapsed":"content-wrapper"}>
            <section className="section-wrapper">
                <div className="page-title">My Documents</div>
                <div className="section-content">
                    {showingList && !showingDetail && <DocumentTypesComp list={docTypes} addNewClickHandler = {addNewClickHandler}/>}
                    <div>
                        {showingList && <DocumentSearch handleUpdate={handleUpdate} showingDetail={setShowingDetail} docId={props.match.params.id} t={props.match.params.t}/>}
                        {showingEditor && <DocumentEditor handleClose={showListHandler} editorItem={editorItem} editorMode={editorMode}/>}
                        {showError && <ErrorComp />}
                        {loading && <LoadingComp />}
                    </div>
                </div>
            </section>
        </div>
    )
}

export default DocumentComp
